import DOMPurify from "dompurify";

export const HtmlContent = ({ html, className = "" }) => {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  return <div className={`rich-html ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
};
